import request from '@/utils/request'

// 获取采购合同变更主表信息
export function coopPayCreateHead(businessId) {
  return request({
    url: `/api/coop/cmContractModifyApply/getObjWithAttach/${businessId}`,
    method: 'get'
  })
}

// 产品信息查询
export function selectProductDetail(query) {
  return request({
    url: '/api/coop/cmContractModifyItem/queryByApplyId',
    method: 'get',
    params: query
  })
}

// 合同阶段查询
export function selectPayStageData(query) {
  return request({
    url: '/api/coop/cmContractModifyPayStage/queryByApplyId',
    method: 'get',
    params: query
  })
}

// 获取采购合同变更源主表信息
export function getObjByUuid(uuid) {
  return request({
    url: '/api/coop/cmPurchaseContractHistory/getObjByUuid/' + uuid,
    method: 'get'
  })
}

// 获取所有合同类型
export function getAllContractType(query) {
  return request({
    url: '/api/coop/cmContractTypeConfig/getAllContractType',
    method: 'get',
    params: query
  })
}

// 根据申请单ID查询采购合同变更申请单审批级别
export function getApprovalLevel(id) {
  return request({
    url: '/api/coop/cmContractModifyApply/getApprovalLevel/' + id,
    method: 'get'
  })
}
